import { useMemo, useState } from "react";
import { useRides, useSummary } from "../hooks/useApi";
import { SummaryPanel } from "../components/SummaryPanel";
import { RideCard } from "../components/RideCard";
import { UploadDialog } from "../components/UploadDialog";

export function DashboardPage() {
  const { data: summary, isLoading: summaryLoading } = useSummary();
  const { data: rides, isLoading: ridesLoading, isError } = useRides();
  const [query, setQuery] = useState("");
  const [uploadOpen, setUploadOpen] = useState(false);

  const filtered = useMemo(() => {
    if (!rides) return [];
    const q = query.trim().toLowerCase();
    if (!q) return rides;
    return rides.filter((r) => r.title.toLowerCase().includes(q));
  }, [rides, query]);

  return (
    <div className="mx-auto max-w-5xl px-4 py-6 sm:px-6">
      <div className="mb-6 flex items-center justify-between gap-3">
        <h1 className="text-2xl font-semibold tracking-tight">Dashboard</h1>
        <button
          type="button"
          onClick={() => setUploadOpen(true)}
          className="flex shrink-0 items-center gap-1.5 rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-brand-700"
        >
          <span aria-hidden>⬆️</span>
          Upload
        </button>
      </div>

      <section className="mb-8">{!summaryLoading && summary && <SummaryPanel summary={summary} />}</section>

      <section>
        <div className="mb-3 flex items-center justify-between gap-3">
          <h2 className="text-lg font-semibold">Rides</h2>
          <input
            type="search"
            placeholder="Search rides…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="w-48 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-sm dark:border-night-700 dark:bg-night-900"
          />
        </div>

        {ridesLoading && <p className="text-slate-500 dark:text-night-400">Loading rides…</p>}
        {isError && <p className="text-red-600 dark:text-red-400">Failed to load rides.</p>}
        {!ridesLoading && filtered.length === 0 && (
          <div className="rounded-xl border border-dashed border-slate-300 p-8 text-center text-slate-500 dark:border-night-700 dark:text-night-400">
            {rides && rides.length > 0 ? (
              "No rides match your search."
            ) : (
              <>
                No rides yet —{" "}
                <button type="button" onClick={() => setUploadOpen(true)} className="text-brand-600 hover:underline dark:text-brand-400">
                  upload your first CSV recording
                </button>
                .
              </>
            )}
          </div>
        )}
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((ride) => (
            <RideCard key={ride.id} ride={ride} />
          ))}
        </div>
      </section>

      <UploadDialog open={uploadOpen} onClose={() => setUploadOpen(false)} />
    </div>
  );
}
